<div class="language-element">
  <span [ngClass]="['flag-icon', countryCode | languageFlagIcon]"></span>
  @if (showCountryCode) {
    <span>{{ countryCode | uppercase }}</span>
  }
</div>
